import faceIcon from '../redes/facebook-icon.png';
import instaIcon from '../redes/instagram-icon.png';
import tiktokIcon from '../redes/tiktok.png';
import faceBack from '../redes/facebook-back.jpg';
import instaBack from '../redes/instagram-back.jpg';
import tiktokBack from '../redes/tiktok-back.jpg';

// Función para generar la URL de cada red social de manera segura
const generarURL = (red, dominio) => {
  return red ? `https://${red}` : dominio;
};

// Función principal que construye las redes sociales a partir de la información de la empresa
const redesSociales = (empresa = {}) => {
  const redes = [];

  const facebookURL = generarURL(empresa?.emp_facebook, "https://facebook.com");
  const instagramURL = generarURL(empresa?.emp_instagram, "https://instagram.com");
  const tiktokURL = generarURL(empresa?.emp_tiktok, "https://www.tiktok.com");

  if (empresa?.emp_facebook) {
    redes.push({
      nombre: "Facebook",
      url: facebookURL,
      icono: faceIcon,
      imagen: faceBack,
    });
  }

  if (empresa?.emp_instagram) {
    redes.push({
      nombre: "Instagram",
      url: instagramURL,
      icono: instaIcon,
      imagen: instaBack,
    });
  }

  if (empresa?.emp_tiktok) {
    redes.push({
      nombre: "TikTok",
      url: tiktokURL,
      icono: tiktokIcon,
      imagen: tiktokBack,
    });
  }
  return redes;
};

export default redesSociales;
